import { _errMissing, _errUnexpected, customError } from "@/app/errors"

export function errUnexpectedSeriesType(name: string, got: string) {
  return _errUnexpected("ERR-GD-01", "type for series", "array", got, { name })
}

export function errEmptySeries(name: string) {
  return _errMissing("ERR-GD-02", "series", { name })
}

export function errUnexpectedRowType(name: string, idx: number, got: string) {
  return _errUnexpected("ERR-GD-03", "type for row", "array", got, {
    name,
    idx,
  })
}

export function errUnexpectedRowLength(
  name: string,
  idx: number,
  expected: number,
  got: number
) {
  return _errUnexpected("ERR-GD-04", "length for row", expected, got, {
    name,
    idx,
  })
}

export function errUnexpectedHeadersType(name: string, got: string) {
  return _errUnexpected("ERR-GD-05", "type for headers", "array", got, { name })
}

export function errUnexpectedHeadersLength(
  name: string,
  expected: number,
  got: number
) {
  return _errUnexpected("ERR-GD-06", "length for headers", expected, got, {
    name,
  })
}

export function errUnexpectedFormattersNumber(
  name: string,
  expected: string,
  got: number | undefined
) {
  return customError(
    "ERR-GD-07",
    `Unexpected number of formatters for ${name}. Expected: ${expected}, Got:${got}`
  )
}

export function errUnexpectedExportersNumber(
  name: string,
  expected: string,
  got: number | undefined
) {
  return customError(
    "ERR-GD-08",
    `Unexpected number of exporters for ${name}. Expected: ${expected}, Got:${got}`
  )
}
